/* ============================================================
   RF2T Cyberpunk 2089 Easter Egg
   ------------------------------------------------------------
   Watches the home-page cipher form (sections/rf2t-cipher.liquid).
   The intended passcode is 2089 written in binary — 100000101001.
   Any binary form of 2089 is accepted (spaces / leading zeros are
   ignored); plain "2089" is not, so the puzzle stands.

   On success it flips the whole site into a neon "Cyberpunk 2089"
   skin (see rf2t-cyberpunk.css). Nothing is persisted — a hard
   refresh loads the normal store. ESC disconnects.

   Loaded globally from theme.liquid so the skin survives spa-nav
   content swaps; the form is reached via event delegation.
   ============================================================ */
(function () {
  'use strict';

  if (window.__rf2tCyberBound) return;
  window.__rf2tCyberBound = true;

  var active = false;

  /* ── Passcodes (extensible: add more { match, run } entries) ── */
  function bitsToInt(raw) {
    var bits = (raw || '').replace(/[^01]/g, '');
    if (!bits) return NaN;
    return parseInt(bits, 2);
  }
  var CODES = [
    { name: '2089', match: function (raw) { return bitsToInt(raw) === 2089; }, run: function () { activate(); } }
  ];

  function handleSubmit(form) {
    var input = form.querySelector('.rf2t-cipher__input') || form.querySelector('input');
    var msg = form.parentNode && form.parentNode.querySelector('[data-rf2t-cipher-msg]');
    var raw = input ? input.value : '';

    for (var i = 0; i < CODES.length; i++) {
      if (CODES[i].match(raw)) {
        if (msg) { msg.textContent = 'ACCESS GRANTED'; msg.style.color = 'var(--cp-cyan)'; }
        if (input) input.blur();
        CODES[i].run();
        return;
      }
    }
    // denied
    if (msg) { msg.textContent = 'ACCESS DENIED'; msg.style.color = ''; }
    form.classList.remove('rf2t-cipher--deny');
    void form.offsetWidth;
    form.classList.add('rf2t-cipher--deny');
    denySound();
    if (input && input.select) input.select();
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('form[data-rf2t-cipher]');
    if (!form) return;
    e.preventDefault();
    resumeAudio();
    handleSubmit(form);
  });

  /* ── Activation ────────────────────────────────────────────── */
  var fx = null, bar = null;
  var KATA = 'アァカサタナハマヤラワガザダバパイィキシチニヒミリギジヂビピウゥクスツヌフムユルグズブプエェケセテネヘメレゲゼデベペオォコソトノホモヨロヲゴゾドボポンヴッ0123456789';

  function randKata(n) {
    var s = '';
    for (var i = 0; i < n; i++) s += KATA.charAt(Math.floor(Math.random() * KATA.length));
    return s;
  }

  function buildFx() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    fx = document.createElement('div');
    fx.className = 'rf2t-2089-fx';
    fx.setAttribute('aria-hidden', 'true');

    var grid = document.createElement('div');
    grid.className = 'rf2t-2089-grid';
    fx.appendChild(grid);

    var cols = reduce ? 0 : 14;
    for (var i = 0; i < cols; i++) {
      var col = document.createElement('div');
      col.className = 'rf2t-2089-rain__col';
      var str = randKata(40);
      col.textContent = str + str;                       // duplicate => seamless loop
      col.style.left = (i / cols * 100 + Math.random() * 3) + '%';
      col.style.setProperty('--fs', (12 + Math.random() * 12).toFixed(0) + 'px');
      col.style.setProperty('--op', (0.10 + Math.random() * 0.16).toFixed(2));
      col.style.setProperty('--dur', (6 + Math.random() * 8).toFixed(1) + 's');
      col.style.setProperty('--delay', (-Math.random() * 8).toFixed(1) + 's');
      fx.appendChild(col);
    }
    document.body.appendChild(fx);

    bar = document.createElement('div');
    bar.className = 'rf2t-2089-bar';
    bar.setAttribute('aria-hidden', 'true');
    var track = document.createElement('div');
    track.className = 'rf2t-2089-bar__track';
    var seg = '　//　RETRO FIX 2089　//　ACCESS GRANTED　//　東京　接続完了　//　サイバーパンク　//　SYSTEM ONLINE　//　[ESC] DISCONNECT　';
    track.textContent = seg + seg;                       // duplicate => seamless -50% loop
    bar.appendChild(track);
    document.body.appendChild(bar);
  }

  function flash() {
    var f = document.createElement('div');
    f.className = 'rf2t-2089-flash';
    f.innerHTML =
      '<div>' +
        '<div class="rf2t-2089-flash__title" data-text="ACCESS GRANTED">ACCESS GRANTED</div>' +
        '<div class="rf2t-2089-flash__sub">接続完了 — RETRO FIX 2089</div>' +
      '</div>';
    document.body.appendChild(f);
    setTimeout(function () { if (f.parentNode) f.parentNode.removeChild(f); }, 3300);
  }

  function activate() {
    if (active) return;
    active = true;
    document.documentElement.classList.add('rf2t-2089');
    buildFx();
    flash();
    grantSound();
    // Let opted-in sections (e.g. the SF2 arcade -> Wolf transmission) react.
    document.dispatchEvent(new CustomEvent('rf2t:cyber', { detail: { on: true } }));
  }

  function deactivate() {
    if (!active) return;
    active = false;
    document.documentElement.classList.remove('rf2t-2089');
    if (fx && fx.parentNode) fx.parentNode.removeChild(fx);
    if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
    fx = bar = null;
    document.dispatchEvent(new CustomEvent('rf2t:cyber', { detail: { on: false } }));
  }

  document.addEventListener('keydown', function (e) {
    if (active && e.key === 'Escape') deactivate();
  });

  /* ── Audio (synthesized) ───────────────────────────────────── */
  var actx = null, master = null;
  function ensureAudio() {
    if (actx) return actx;
    var AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    try {
      actx = new AC();
      master = actx.createGain();
      master.gain.value = 0.2;
      master.connect(actx.destination);
    } catch (_) { actx = null; }
    return actx;
  }
  function resumeAudio() {
    var c = ensureAudio();
    if (c && c.state === 'suspended') c.resume();
  }
  function tone(type, f, at, dur, g, glide) {
    if (!actx) return;
    var o = actx.createOscillator(), ga = actx.createGain();
    o.type = type;
    o.frequency.setValueAtTime(f, at);
    if (glide && glide !== f) o.frequency.exponentialRampToValueAtTime(Math.max(1, glide), at + dur);
    ga.gain.setValueAtTime(0.0001, at);
    ga.gain.exponentialRampToValueAtTime(g, at + 0.01);
    ga.gain.exponentialRampToValueAtTime(0.0001, at + dur);
    o.connect(ga).connect(master);
    o.start(at); o.stop(at + dur + 0.02);
  }
  function noiseBurst(at, dur, g) {
    if (!actx) return;
    var len = Math.max(1, Math.floor(actx.sampleRate * dur));
    var b = actx.createBuffer(1, len, actx.sampleRate);
    var d = b.getChannelData(0);
    for (var i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
    var s = actx.createBufferSource(); s.buffer = b;
    var bp = actx.createBiquadFilter(); bp.type = 'bandpass'; bp.frequency.value = 1400; bp.Q.value = 0.7;
    var ga = actx.createGain();
    ga.gain.setValueAtTime(g, at);
    ga.gain.exponentialRampToValueAtTime(0.0001, at + dur);
    s.connect(bp).connect(ga).connect(master);
    s.start(at); s.stop(at + dur);
  }
  function grantSound() {
    if (!ensureAudio()) return;
    resumeAudio();
    var t = actx.currentTime + 0.02;
    noiseBurst(t, 0.28, 0.12);
    tone('sawtooth', 110, t, 0.5, 0.18, 55);
    [330, 440, 554, 659, 880].forEach(function (f, i) { tone('square', f, t + 0.16 + i * 0.08, 0.18, 0.15); });
    tone('triangle', 880, t + 0.62, 0.6, 0.12, 1760);
  }
  function denySound() {
    if (!ensureAudio()) return;
    resumeAudio();
    var t = actx.currentTime + 0.02;
    tone('square', 180, t, 0.18, 0.18, 90);
    tone('square', 150, t + 0.12, 0.22, 0.18, 70);
  }
})();
